// Process-wide toggle for opting Apollo operations out of HTTP batching. The dashboard enables this
// while mounted: batching there couples every card to the slowest query in the batch, so we'd rather
// each card's request go independently. The Apollo auth link reads this at operation time and the batch
// `split` routes accordingly; the rest of the app keeps batching.
//
// This is a reference count, not a boolean, so it survives a remount. On a keyed remount React runs the
// new instance's render (acquire) and then the old instance's cleanup (release) in the same commit,
// before the new children's query effects fire — a boolean would be left false at query time, but the
// count stays > 0 because the acquire happens before the release.
let activeScopeCount = 0;

export function isApolloBatchingDisabled(): boolean {
  return activeScopeCount > 0;
}

export function acquireApolloBatchingDisabled(): void {
  activeScopeCount += 1;
}

export function releaseApolloBatchingDisabled(): void {
  activeScopeCount = Math.max(0, activeScopeCount - 1);
}
